export const minimumDelay = (ms: number): Promise<void> =>
  new Promise(resolve => {
    globalThis.setTimeout(resolve, ms);
  });

export const runLoginPostSubmitFlow = async (options: {
  minimumLoadingMs?: number;
  warmupTask: () => Promise<void>;
}): Promise<void> => {
  const minimumLoadingMs = options.minimumLoadingMs ?? 2000;

  await Promise.all([
    minimumDelay(minimumLoadingMs),
    options
      .warmupTask()
      .catch(() => {
        // warm-up is best-effort and must not block login success
      }),
  ]);
};
